import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { background, boxModel, css } from '../util'
import { backgroundTypes, boxModelTypes, cssTypes } from '../types'

/**
 * @namespace StyledTableRow
 * @desc Primitive styled-component 💅
 * @return {Function} React component
 */
const StyledTableRow = styled.tr`
  ${background};
  ${boxModel};
  ${css};
`

const TableRow = props => (
  <StyledTableRow {...props}>{props.children}</StyledTableRow>
)

/**
 * @name defaultProps
 * @memberof StyledTableRow
 * @desc Primitive's default properties
 */
StyledTableRow.defaultProps = {
  margin: [0],
  padding: [0],
  size: ['auto'],
}

/**
 * @name propTypes
 * @memberof StyledTableRow
 * @desc Primitive's prop type definitions
 */
StyledTableRow.propTypes = {
  children: PropTypes.any.isRequired,
  ...backgroundTypes,
  ...boxModelTypes,
  ...cssTypes,
}

/** @component */
export default TableRow
